/* Code from https://www.w3schools.com/howto/howto_custom_select.asp */
function customSelectsInit() {
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName("custom-select");
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    if(selElmnt.selectedIndex != 0) {
      a.innerHTML = `<img src="${selElmnt.options[selElmnt.selectedIndex].dataset.variantImage}" alt="${selElmnt.options[selElmnt.selectedIndex].innerHTML}"><p>${selElmnt.options[selElmnt.selectedIndex].innerHTML}</p>`;
    } else {
      a.innerHTML = `<p>${selElmnt.options[selElmnt.selectedIndex].innerHTML}</p>`;
    }
    x[i].appendChild(a);
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
      c = document.createElement("DIV");
      c.innerHTML = `<img src="${selElmnt.options[j].dataset.variantImage}" alt="${selElmnt.options[j].innerHTML}"/><p>${selElmnt.options[j].innerHTML}</p>`;
      c.addEventListener("click", function(e) {
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (this.innerHTML.includes(s.options[i].innerHTML) && this.innerHTML.includes(s.options[i].dataset.variantImage)) {
              s.selectedIndex = i;
              if(s.classList.contains("single-option-selector__radio")) {
                $('.single-option-selector__radio').trigger({type: 'change'});
              }
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function(e) {

      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
  }

  function closeAllSelect(elmnt) {
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add("select-hide");
      }
    }
  }

  document.addEventListener("click", closeAllSelect);
}

customSelectsInit();
